/* EVERLA "What stopped you?" + checkout-trip marker (2026-10-14). Markup and styles: snippets/ev-exit-survey.liquid.
   1. Remembers which ad a shopper came from (utm_content) for the checkout pixel (Shopify custom pixel
      "EVERLA checkout insight", ops/checkout-insight-2026-10-14/pixel.js), which also marks checkout trips.
   2. Marks a trip to checkout from the bag or /cart.
   3. When that shopper is back on the site (fresh load or Back) with the bag still full, it tags Clarity with the furthest
      checkout step, logs the return, and asks once (then not for 30 days) what stopped them. An empty bag means they
      bought (or emptied it), so nothing is asked.
   Rows go to the insert-only table public.ev_checkout_events; nothing a shopper types into checkout is ever read. */
(function () {
  'use strict';
  var EV_URL = 'https://rzkcwxmvevmbwtojuqvz.supabase.co/rest/v1/ev_checkout_events';
  var EV_KEY = 'sb_publishable_4DoH4T3RamKpqwQaAhiggA_KvC39NQV';
  var DAY = 864e5;
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch (e) {} }
  };
  try {
    var q = new URLSearchParams(location.search), src = q.get('utm_content') || q.get('utm_campaign');
    if (src) ls.set('ev_src', src.slice(0, 96));
  } catch (e) {}
  var mark = function () { ls.set('ev_co_left', String(Date.now())); };
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-ev-checkout]')) mark(); }, true);
  document.addEventListener('submit', function (e) { var f = e.target; if (f && f.querySelector && f.querySelector('[name="checkout"]')) mark(); }, true);

  var box = document.querySelector('[data-ev-exit]');
  if (!box) return;
  var ask = box.querySelector('[data-ev-exit-ask]'), thanks = box.querySelector('[data-ev-exit-thanks]'), other = box.querySelector('[data-ev-exit-other]');

  if (/^es\b/i.test(navigator.language || '')) {
    var ES = { k: 'Una pregunta rápida', t: '¿Qué te frenó al pagar?', price: 'El precio', delivery_time: 'El tiempo de entrega', looks_real: 'No sé si se ve real', just_looking: 'Solo estoy mirando', other: 'Otra cosa', other_label: 'Cuéntanos en pocas palabras', send: 'Enviar', thanks_t: 'Gracias.', thanks_p: 'Nos ayuda mucho. Tu bolsa queda guardada para cuando quieras.', cta: '15% de descuento en tu primera compra' };
    Array.prototype.forEach.call(box.querySelectorAll('[data-i18n]'), function (el) { var t = ES[el.getAttribute('data-i18n')]; if (t) el.textContent = t; });
    box.querySelector('#EvExitTitle').setAttribute('lang', 'es');
    box.setAttribute('lang', 'es');
  }

  function clientId() { var m = document.cookie.match(/(?:^|; )_shopify_y=([^;]*)/); return m ? decodeURIComponent(m[1]).slice(0, 64) : ''; }
  function device() {
    var ua = navigator.userAgent || '';
    var app = /FBAN|FBAV|FB_IAB/.test(ua) ? 'fb' : /Instagram/.test(ua) ? 'ig' : /CriOS|Chrome/.test(ua) ? 'chrome' : /Safari/.test(ua) ? 'safari' : 'other';
    var os = /iPhone|iPad|iPod/.test(ua) ? 'ios' : /Android/.test(ua) ? 'android' : 'desktop';
    return app + '-' + os;
  }
  function progress() { try { return JSON.parse(ls.get('ev_co_progress') || 'null') || {}; } catch (e) { return {}; } }
  function send(row) {
    var body = { client_id: clientId() || null, device: device(), source: (ls.get('ev_src') || '').slice(0, 96) || null };
    for (var k in row) body[k] = row[k];
    try { fetch(EV_URL, { method: 'POST', keepalive: true, headers: { apikey: EV_KEY, Authorization: 'Bearer ' + EV_KEY, 'Content-Type': 'application/json', Prefer: 'return=minimal' }, body: JSON.stringify(body) }).catch(function () {}); } catch (e) {}
  }
  function clarity() { try { if (typeof window.clarity === 'function') window.clarity.apply(window, arguments); } catch (e) {} }
  function busy() {
    var w = document.getElementById('EverlaWelcome');
    // The bag is not "busy": Back from checkout restores the page with the bag still open, and that is the moment to ask,
    // so the question then sits on top of the bag (.is-over-bag).
    return !!(document.querySelector('.ev-modal.is-open,.ev-search.is-open,.ev-drawer.is-open,.ev-zoom.is-open,dialog[open]') || (w && !w.hidden && getComputedStyle(w).display !== 'none'));
  }

  var shown = false, step = '';
  function open() {
    if (shown) return;
    if (busy()) { setTimeout(open, 2000); return; }
    shown = true; ls.set('ev_co_asked', String(Date.now()));
    box.classList.toggle('is-over-bag', !!document.querySelector('.ev-cart.is-open'));
    box.hidden = false; requestAnimationFrame(function () { box.classList.add('is-on'); });
    send({ event: 'exit_survey_shown', step: step || null });
  }
  function close(why) {
    box.classList.remove('is-on'); setTimeout(function () { box.hidden = true; }, 260);
    if (why === 'dismissed') { send({ event: 'exit_survey_dismissed', step: step || null }); clarity('event', 'exit_survey_dismissed'); }
  }
  function answer(key, text) {
    var row = { event: 'exit_survey', field: key, step: step || null };
    if (text) row.detail = { text: String(text).slice(0, 140) };
    send(row);
    clarity('set', 'exit_reason', key); clarity('event', 'exit_survey_' + key);
    ask.hidden = true; thanks.hidden = false;
    ls.del('ev_co_left');
  }
  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-ev-exit-close]')) { close('dismissed'); return; }
    var b = e.target.closest('[data-ev-exit-answer]'); if (!b) return;
    var key = b.getAttribute('data-ev-exit-answer');
    if (key === 'other') { b.setAttribute('aria-pressed', 'true'); other.hidden = false; var i = other.querySelector('input'); if (i) i.focus(); return; }
    answer(key);
  });
  other.addEventListener('submit', function (e) { e.preventDefault(); var i = other.querySelector('input'); answer('other', i ? i.value.trim() : ''); });
  thanks.addEventListener('click', function (e) {
    if (!e.target.closest('[data-everla-welcome-open]')) return;
    send({ event: 'exit_survey_offer_click', step: step || null });
    // The welcome pop-up won't open over the bag: close the bag first (this runs before the pop-up's document listener).
    var keep = document.querySelector('.ev-cart.is-open [data-ev-close]'); if (keep) keep.click();
    close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close('dismissed'); });

  function check() {
    if (shown) return;
    var left = +ls.get('ev_co_left') || 0;
    if (!left || Date.now() - left > 3 * DAY) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !cart.item_count) { ls.del('ev_co_left'); return; } // bought, or emptied the bag
      var p = progress(); step = p.step || '';
      if (!ls.get('ev_co_returned') || +ls.get('ev_co_returned') < left) {
        ls.set('ev_co_returned', String(Date.now()));
        clarity('set', 'checkout_step', step || 'unknown'); clarity('event', 'returned_from_checkout');
        send({ event: 'returned_from_checkout', step: step || null, ms: Math.min(604800000, Math.max(0, Date.now() - left)) });
      }
      var asked = +ls.get('ev_co_asked') || 0;
      if (asked && Date.now() - asked < 30 * DAY) return;
      setTimeout(open, 1200);
    }).catch(function () {});
  }
  // pageshow covers the first load and a Back from checkout restored from the back/forward cache.
  window.addEventListener('pageshow', check);
})();
